<template>
    <div class="box">
        <img class="logo" src="../assets/logo.webp" />
        <div class="btns">
            <div class="btn" v-for="btn in btns" :key="btn.name" @click="handleClick(btn.path)" :style="{
                backgroundColor: btn.name === cur ? '#2EC8FC' : 'none',
            }">
                {{ btn.name }}
            </div>
        </div>
    </div>
</template>
<script setup>
import { defineProps } from "vue";
import { useRouter } from "vue-router";
defineProps({
    cur: {
        type: String,
        required: true,
        default: "Trang Chủ",
    },
});
const router = useRouter();
const btns = [
    {
        name: "Trang Chủ",
        path: "/",
    },

    {
        name: "Giới Thiệu",
        path: "/about",
    },
    {
        name: "Dịch Vụ",
        path: "/service",
    },
    {
        name: "Liên Hệ",
        path: "/contact",
    },
    {
        name: "Chính sách bảo mật",
        path: "/privatePolicy",
    },
    {
        name: "Thỏa thuận vay",
        path: "/loanAgreement",
    }
];
const handleClick = (path) => {
    console.log("path", path);
    router.replace(path);
};
</script>
<style lang="less" scoped>
.box {
    height: 120px;
    padding: 0 149px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .logo {
        width: 373px;
        object-fit: contain;
    }

    .btns {
        display: flex;

        .btn {
            font-weight: bold;
            font-size: 20px;
            line-height: 120px;
            color: #FFFFFF;
            cursor: pointer;
            height: 120px;
            box-sizing: border-box;
            padding: 5px 16px;
            text-align: center;
            text-wrap: nowrap;
        }
    }
}
</style>